import { render, staticRenderFns } from "./DocStatementExport.vue?vue&type=template&id=67e207e4"
import script from "./DocStatementExport.vue?vue&type=script&lang=js"
export * from "./DocStatementExport.vue?vue&type=script&lang=js"
import style0 from "./DocStatementExport.vue?vue&type=style&index=0&id=67e207e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports